import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalClose,
  ModalDialog,
  Option,
  Select,
  Sheet,
  Typography,
} from '@mui/joy';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SearchIcon from '@mui/icons-material/Search';
import React from 'react';
import { IInvoiceFilter } from '../interface/IInvoice';

type Props = {
  filters: IInvoiceFilter;
  offerIds: string[];
  onFilterChange: (filter: keyof IInvoiceFilter, value: any) => void;
  onFilterReset?: () => void;
  onFilterApply?: () => void;
};

const InvoiceTableFilter = ({ filters, offerIds, onFilterChange, onFilterReset, onFilterApply }: Props) => {
  const [open, setOpen] = React.useState(false);

  const renderFilters = () => (
    <React.Fragment>
      <FormControl size='sm'>
        <FormLabel>Offer Id</FormLabel>
        <Select size='sm' placeholder='All' value={filters.offerId ?? ''} onChange={(e, value) => onFilterChange('offerId', value)}>
          <Option value='all'>All</Option>
          {offerIds &&
            offerIds.map((offerId) => (
              <Option key={offerId} value={offerId}>
                {offerId}
              </Option>
            ))}
        </Select>
      </FormControl>
      <FormControl size='sm'>
        <FormLabel>Invoice Month</FormLabel>
        <Input name='invoiceMonth' type='month' value={filters.invoiceMonth ?? ''} onChange={(e) => onFilterChange('invoiceMonth', e.target.value)} />
      </FormControl>
      <FormControl size='sm'>
        <FormLabel>Payment Month</FormLabel>
        <Input name='paymentMonth' value={filters.paymentMonth ?? ''} type='date' onChange={(e) => onFilterChange('paymentMonth', e.target.value)} />
      </FormControl>
      <FormControl size='sm'>
        <FormLabel>Status</FormLabel>
        <Select size='sm' placeholder='All' onChange={(e, value) => onFilterChange('status', value)} value={filters.status ?? ''}>
          <Option value='all'>All</Option>
          <Option value='saved'>Saved</Option>
          <Option value='emailSent'>Email Sent</Option>
          <Option value='paid'>Paid</Option>
        </Select>
      </FormControl>
      <FormControl size='sm' sx={{ alignSelf: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            '& > div': { p: 2, borderRadius: 'md', display: 'flex' },
          }}
        >
          <Sheet variant='outlined'>
            <Checkbox
              overlay
              checked={filters.externalInvoices}
              label='External Invoices'
              onChange={(e) => onFilterChange('externalInvoices', e.target.checked)}
            />
          </Sheet>
        </Box>
      </FormControl>
    </React.Fragment>
  );

  return (
    <div>
      <Sheet
        className='SearchAndFilters-mobile'
        sx={{
          display: { xs: 'flex', sm: 'none' },
          my: 1,
          gap: 1,
        }}
      >
        <Input
          size='sm'
          placeholder='Search'
          startDecorator={<SearchIcon />}
          sx={{ flexGrow: 1 }}
          value={filters.search}
          onChange={(e) => onFilterChange('search', e.target.value)}
        />
        <IconButton size='sm' variant='outlined' color='neutral' onClick={() => setOpen(true)}>
          <FilterAltIcon />
        </IconButton>
        <Modal open={open} onClose={() => setOpen(false)}>
          <ModalDialog aria-labelledby='filter-modal' layout='fullscreen'>
            <ModalClose />
            <Typography id='filter-modal' level='h2'>
              Filters
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Sheet sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {renderFilters()}
              <Button color='primary' onClick={() => setOpen(false)}>
                Submit
              </Button>
            </Sheet>
          </ModalDialog>
        </Modal>
      </Sheet>
      <Box
        className='SearchAndFilters-tabletUp'
        sx={{
          borderRadius: 'sm',
          py: 2,
          display: { xs: 'none', sm: 'flex' },
          flexWrap: 'wrap',
          gap: 1.5,
          '& > *': {
            minWidth: { xs: '120px', md: '160px' },
          },
        }}
      >
        <FormControl sx={{ flex: 1 }} size='sm'>
          <FormLabel>Search for order</FormLabel>
          <Input
            size='sm'
            placeholder='Search'
            startDecorator={<SearchIcon />}
            value={filters.search ?? ''}
            onChange={(e) => onFilterChange('search', e.target.value)}
          />
        </FormControl>
        {renderFilters()}
        <Button variant='outlined' color='primary' size='sm' onClick={() => onFilterApply?.()} sx={{ alignSelf: 'end' }}>
          Filter
        </Button>
        <Button variant='outlined' color='neutral' size='sm' onClick={() => onFilterReset?.()} sx={{ alignSelf: 'end' }}>
          Reset Filters
        </Button>
      </Box>
    </div>
  );
};

export default InvoiceTableFilter;
